<template>
  <transition name="fade" appear>
    <div class="side-drawer-backdrop backdrop" v-if="showDrawerBackdrop">
      <transition name="slide" appear>
        <div class="side-drawer" v-if="showDrawerPanel" @click.self="closeDrawer">
          <div class="drawer-panel d-flex flex-column align-items-between">
            <slot name="default">
              <div class="panel-header border-bottom border-light px-5 pt-3">
                <slot name="header">
                  <h3 class="drawer-title">
                    {{ drawerTitle }}
                  </h3>
                  <template v-if="drawerSubtitle">
                    <p class="small drawer-subtitle">{{ drawerSubtitle }}</p>
                  </template>
                </slot>
              </div>

              <div class="panel-content flex-grow-1 px-5 pt-3 overflow-auto">
                <slot name="body">
                </slot>
              </div>

              <div class="panel-footer border-top border-light py-3 px-5 text-right">
                <slot name="footer">
                  <button class="btn btn-primary" @click="closeDrawer">Chiudi</button>
                </slot>
              </div>
            </slot>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    drawerTitle: {
      type: String,
    },
    drawerSubtitle: {
      type: String,
    },
  },
  data () {
    return {
      showDrawerBackdrop: true,
      showDrawerPanel: true,
    };
  },
  methods: {
    closeDrawer () {
      this.showDrawerPanel = false;
      setTimeout(() => {
        this.showDrawerBackdrop = false;
        this.$emit('close-drawer');
      }, 300);
    },
  },
};
</script>

<style lang="scss">

.side-drawer-backdrop {
  backdrop-filter: blur(4px);
  background: rgba($black, 0.5);
  height: 100vh;
  position: fixed;
  width: 100vw;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9999;

  .side-drawer {
    height: 100%;
    left: 0;
    position: relative;
    transition: all 0.3s ease-in-out;
    width: 100%;

    .drawer-panel {
      background: #ffffff;
      box-shadow: 0 0 40px -6px rgba(#000000, 0.3);
      height: 100%;
      margin-left: auto;
      width: 65%;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .slide-enter-active,
  .slide-leave-active {
    transition: all 0.3s ease-in-out;
  }

  .slide-enter,
  .slide-leave-to {
    left: 100%;
  }
}

</style>
